import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { Observable } from 'rxjs';
import { BulkDocDeletePayload } from '@models/review/bulk-doc-delete-payload.model';

@Injectable({
    providedIn: 'root'
})
export class BulkDeleteDocsSdk extends SdkBase {
    constructor(injector: Injector) {
        super(injector);
    }

    public deleteDocs(payload: BulkDocDeletePayload): Observable<boolean> {
        return this.makeHttpRequest('post', `api2/docs/bulk/delete`, payload);
    }
}